/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useDebouncedCallback = <A extends Array<any>>(
  callback: (...args: A) => void,
  wait: number,
): ((...args: A) => void) => {
  // track args & timeout handle between calls
  const argsRef = React.useRef<A>();
  const timeout = React.useRef<ReturnType<typeof setTimeout>>();

  function cleanup(): void {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
  }

  // make sure our timeout gets cleared if
  // our consuming component gets unmounted
  React.useEffect(() => cleanup, []);

  const debouncedCallback = (...args: A): void => {
    // capture latest args
    argsRef.current = args;

    // clear debounce timer
    cleanup();

    // start waiting again
    timeout.current = setTimeout(() => {
      if (argsRef.current) {
        callback(...argsRef.current);
      }
    }, wait);
  };

  return debouncedCallback;
};

export default useDebouncedCallback;
